























































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import appconst from '@/lib/appconst';
    import Enums from '@/lib/enums'

    class EditLogistics {
        id: number;
        warehouseId: number;
        shipment: string;
        shelfNumber: string;
        userCode: string;
        processTime?: Date;
        receiveStatus: number;
        imageGuid: string;
        goodsImageGuid: string;
        reMark: string;
        isConfirm: boolean;
    }
    @Component
    export default class EditLogisticsModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        logistics: EditLogistics = new EditLogistics();
        warehouseCityId: number = 0;
        whetherStatus = Enums.getEnum(Enums.WhetherStatus, false);
        warehouseCityList: Array<warehouseCity>=[];
        warehouseInfoList: Array<warehouseInfo> = [];
        isDisplay: string = '';
        imgUrl: string = '';
        goodsimgUrl: string = '';
        selectDate: string = "";
        selectTime: string = "";
        oldReceiveStatus: number;
        isReadOnly = false;
        imgUploadUrl: string = '';
        GoodsimgUploadUrl: string = '';
        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };
        goodsheaders: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };

        created() {
            this.imgUploadUrl = appconst.remoteServiceBaseUrl + "api/services/app/Logistics/UploadLogisticsImg";
            this.GoodsimgUploadUrl = appconst.remoteServiceBaseUrl + "api/services/app/Logistics/UploadLogisticsImg";
        }

        handleSuccess(res, file) {
            if (res.success) {
                this.logistics.imageGuid = res.result;
                this.setImage();
            }
        }
        handleError(res, file) {
            this.$Message.error('上传图片失败。'+res.message);
        }
        handleSuccessGoods(res, file) {
            if (res.success) {
                this.logistics.goodsImageGuid = res.result;
                this.setImage();
            }
        }
        handleErrorGoods(res, file) {
            this.$Message.error('上传图片失败。' + res.message);
        }
        returns() {
            this.logistics.receiveStatus = 3;
            this.save();
        }
        signFor() {
            this.logistics.receiveStatus = 1;
            this.save();
        }
        refusal() {
            this.logistics.receiveStatus = 2;
            this.save();
        }
        saveData() {
            this.logistics.receiveStatus = this.oldReceiveStatus;
            this.save();
        }
        save() {
            (this.$refs.logisticsForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    if (!this.selectDate || this.selectDate.length == 0) {
                        var anyDate: any = this.selectDate;
                        this.logistics.processTime = anyDate;
                    }
                    await this.$store.dispatch({
                        type: 'backlogistics/updateLogistics',
                        data: this.logistics
                    });
                    (this.$refs.logisticsForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }

        async changeWarehouseCity(val: number) {
            this.warehouseInfoList = await this.$store.dispatch({
                type: 'warehouseInfo/get',
                data: { CityId: val }
            });
            if (this.warehouseInfoList.length == 1) {
                this.logistics.warehouseId = this.warehouseInfoList[0].id;
            }
        }
        async getCity() {
            this.warehouseCityList = await this.$store.dispatch({
                type: 'warehouseCity/get',
                data: {}
            });
            if (this.warehouseCityList.length > 0) {
                this.warehouseCityId = this.warehouseCityList[0].id;
                this.changeWarehouseCity(this.warehouseCityId);
            }
        }
        cancel() {
            (this.$refs.logisticsForm as any).resetFields();
            this.$emit('input', false);
        }
        setImage() {
            if (this.logistics.imageGuid && this.logistics.imageGuid.length > 1) {
                var data = { imageGuid: this.logistics.imageGuid, url: null };
                this.$store.commit('backlogistics/getImgUrl', data);
                this.imgUrl = data.url;
            } else {
                this.imgUrl = null;
            }
            if (this.logistics.goodsImageGuid && this.logistics.goodsImageGuid.length > 1) {
                var datas = { goodsImageGuid: this.logistics.goodsImageGuid, urls: null };
                this.$store.commit('backlogistics/getGoodsImgUrl', datas);
                this.goodsimgUrl = datas.urls;
            } else {
                this.goodsimgUrl = null;
            }
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                (this.$refs.logisticsForm as any).resetFields();
                this.isReadOnly = false;
                var data = this.$store.state.backlogistics.logisticsInfo;
                this.isDisplay = "none";
                this.oldReceiveStatus = data.receiveStatus;
                this.logistics.id = data.id;
                this.logistics.shipment = data.shipment;
                this.logistics.userCode = data.userCode?data.userCode:data.orderUserCode;
                this.logistics.receiveStatus = data.receiveStatus;
                this.logistics.imageGuid = data.imageGuid;
                this.logistics.goodsImageGuid = data.goodsImageGuid;
                this.logistics.reMark = data.reMark;
                this.logistics.isConfirm = data.isConfirm;
                this.logistics.shelfNumber = data.shelfNumber;
                this.setImage();
                if (data.orderNumber && data.orderNumber.length > 1) {
                    this.isReadOnly = true;
                }

            }
        }
        logisticsRule  = {
            orderNumber: [
                { required: true, min: 6, max: 200, message: '虾皮订单编号不能为空，且长度必须大于6且小于200', trigger: 'blur' }
            ],
            shipment: [
                {required: true, max: 30, message: '快递单号不能为空，且长度必须小于30', trigger: 'blur' }
            ],
            userCode: [
                {required: true, max: 30, message: '用户编码不能为空，且长度必须小于30', trigger: 'blur' }
            ],
            reMark: [
                { max: 500, message: '长度不能大于500', trigger: 'blur' }
            ]
        };

    }
